// FIXME: Update this configuration file based on your project information

export const AppConfig = {
  username: process.env.REACT_APP_VEC_USERNAME_CHATBOT || '',
  password: process.env.REACT_APP_VEC_PASSWORD_CHATBOT || '',
  endpoint: process.env.REACT_APP_VEC_ENDPOINT_CHATBOT || '',

  opensearchUrl: process.env.REACT_APP_OPEN_SEARCH_ENDPOINT || '',
  usernameOpenSearch: process.env.REACT_APP_OPEN_SEARCH_USERNAME || '',
  passwordOpenSearch: process.env.REACT_APP_OPEN_SEARCH_PASSWORD || '',

  eventLogsUrl: process.env.REACT_APP_EVENT_LOGS_ENDPOINT || '',
  eventLogsApiKey: process.env.REACT_APP_EVENT_LOGS_API_KEY || '',
};
